import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings"
)({
  beforeLoad: ({ location }) => {
    if (
      location.pathname === "/account-settings" ||
      location.pathname === "/account-settings/"
    ) {
      throw redirect({
        to: "/account-settings/$tabKey",
        params: { tabKey: "profile" },
      })
    }
  },
  component: () => <Outlet />,
})
